import { SPECIAL_DAYS } from "./specialDays";
import { T } from "./translations";

const THEME_DREAMSJOBS = "dreamjobs";

export const DREAMJOBS = getQueryVariable("theme") === THEME_DREAMSJOBS;

const SZJA = {
  2017: 0.15,
  2018: 0.15,
  2019: 0.15,
  2020: 0.15,
  2021: 0.15,
  2022: 0.15,
  2023: 0.15,
  2024: 0.15,
  2025: 0.15,
  2026: 0.15,
};

export function getLang() {
  return getQueryVariable("lang") || "hu";
}

export function setLang(lang) {
  setQueryVariable("lang", lang);
}

document.title = T.siteTitle[getLang()];

// Terrible, but uglify does not like arrow functions
export const YEARS = Object.keys(SZJA)
  .map(function(year) {
    return parseInt(year, 10);
  })
  .sort(function(a, b) {
    return a - b;
  });

export const ACT_YEAR = Math.min(
  new Date().getFullYear(),
  YEARS[YEARS.length - 1]
);

const NYUG = {
  2017: 0.1,
  2018: 0.1,
  2019: 0.1,
  2020: 0.1,
  2021: 0.1,
  2022: 0.1,
  2023: 0.1,
  2024: 0.1,
  2025: 0.1,
  2026: 0.1,
};
const EGB = {
  2017: 0.07,
  2018: 0.07,
  2019: 0.07,
  2020: 0.07,
  2021: 0.07,
  2022: 0.07,
  2023: 0.07,
  2024: 0.07,
  2025: 0.07,
  2026: 0.07,
};
const MUNK = {
  2017: 0.015,
  2018: 0.015,
  2019: 0.015,
  2020: 0.015,
  2021: 0.015,
  2022: 0.015,
  2023: 0.015,
  2024: 0.015,
  2025: 0.015,
  2026: 0.015,
};
const SZOHO = {
  2017: 0.22,
  2018: 0.195,
  2019: 0.175,
  2020: 0.155,
  2021: 0.155,
  2022: 0.13,
  2023: 0.13,
  2024: 0.13,
  2025: 0.13,
  2026: 0.13,
};
const SZAK = {
  2017: 0.015,
  2018: 0.015,
  2019: 0.015,
  2020: 0.015,
  2021: 0.015,
  2022: 0,
  2023: 0,
  2024: 0,
  2025: 0,
  2026: 0,
};
const CSALADI = {
  2017: {
    1: 10000,
    2: 15000,
    3: 33000,
  },
  2018: {
    1: 10000,
    2: 17500,
    3: 33000,
  },
  2019: {
    1: 10000,
    2: 20000,
    3: 33000,
  },
  2020: {
    1: 10000,
    2: 20000,
    3: 33000,
  },
  2021: {
    1: 10000,
    2: 20000,
    3: 33000,
  },
  2022: {
    1: 10000,
    2: 20000,
    3: 33000,
  },
  2023: {
    1: 10000,
    2: 20000,
    3: 33000,
  },
  2024: {
    1: 10000,
    2: 20000,
    3: 33000,
  },
  2025: {
    1: 15000,
    2: 30000,
    3: 49500,
  },
  2026: {
    1: 20000,
    2: 40000,
    3: 66000,
  },
};

export const MINIMALBER = {
  2017: 127500,
  2018: 138000,
  2019: 149000,
  2020: 161000,
  2021: 167400,
  2022: 200000,
  2023: 232000,
  2024: 266800,
  2025: 290800,
  2026: 322800,
};
export const BERMINIMUM = {
  2017: 161000,
  2018: 180500,
  2019: 195000,
  2020: 210600,
  2021: 219000,
  2022: 260000,
  2023: 296400,
  2024: 326000,
  2025: 348820,
  2026: 373200,
};
export const ATLAGBER = {
  2017: 290600,
  2018: 329900,
  2019: 365000,
  2020: 388000,
  2021: 440600,
  2022: 515800,
  2023: 555900,
  2024: 555900,
  2025: 627400,
  2026: 692700,
};
// 25 év alattiak SZJA kedvezményének maximuma
// a tárgyévet megelőző július hónapra a KSH által közzétett nemzetgazdasági szintű bruttó átlagkereset SZJA tartalma
// https://nav.gov.hu/print/ado/szja/SZJA-kedvezmenyek_havi_osszegei_2019-tol
export const FIATAL_KEDVEZMENY_MAX = {
  2022: 65055,
  2023: 74992,
  2024: 86490,
  2025: 98518,
  2026: 98518,
};

export const SZJA_INDEX = 0;
export const NETTO_INDEX = 4;
export const CURR_FORMAT = new Intl.NumberFormat("hu-HU", {
  style: "currency",
  currency: "HUF",
  useGrouping: true,
  minimumFractionDigits: 0,
});

export function getDataDesc(year, lang) {
  return [
    [
      "szja",
      T.szja[lang] + " (" + SZJA[year] * 100 + "%): ",
      DREAMJOBS ? "#fff" : "#1f77b4",
    ],
    [
      "nyug",
      T.nyug[lang] + " (" + NYUG[year] * 100 + "%): ",
      DREAMJOBS ? "#fff" : "#ff7f0e",
    ],
    [
      "egb",
      T.egb[lang] + " (" + Math.round(EGB[year] * 100) + "%): ",
      DREAMJOBS ? "#fff" : "#2ca02c",
    ],
    [
      "munk",
      T.munk[lang] + " (" + MUNK[year] * 100 + "%): ",
      DREAMJOBS ? "#fff" : "#9467bd",
    ],
    ["netto", T.netto[lang] + ": ", "#d62728"],
    [
      "szoho",
      T.szoho[lang] + " (" + SZOHO[year] * 100 + "%): ",
      DREAMJOBS ? "#fff" : "#8c564b",
    ],
    [
      "szak",
      T.szak[lang] + " (" + SZAK[year] * 100 + "%): ",
      DREAMJOBS ? "#fff" : "#e377c2",
    ],
  ];
}

export function getQueryVariable(variable) {
  var query = window.location.search.substring(1);
  var vars = query.split("&");
  for (var i = 0; i < vars.length; i++) {
    var pair = vars[i].split("=");
    if (pair[0] == variable) {
      return pair[1];
    }
  }
  return "";
}

export function setQueryVariable(name, value) {
  var query = window.location.search.substring(1);
  var vars = query.split("&");
  var found = false;
  for (var i = 0; i < vars.length; i++) {
    var pair = vars[i].split("=");
    if (pair[0] == name) {
      pair[1] = value;
      vars[i] = pair.join("=");
      found = true;
    }
  }
  if (!found) {
    vars.push(name + "=" + value);
  }
  const newQuery = vars.join("&");
  const newUrl =
    window.location.protocol +
    "//" +
    window.location.host +
    window.location.pathname +
    "?" +
    newQuery;
  window.history.pushState({ path: newUrl }, "", newUrl);
}

export function bruttoToData(
  year,
  brutto,
  kedv,
  nemkedv,
  elsoHazas,
  fiatal,
  sickleaveMonth,
  sickleaveCount,
  szjaMentesAnya,
  fiatalanya,
  szemelyi
) {
  var data = {};
  var countOfWorkdays = calcWorkDays(year, sickleaveMonth);
  console.log("workdays: ", countOfWorkdays);
  if (sickleaveCount > 0) {
    var tavolletidij = brutto / countOfWorkdays;
    brutto =
      tavolletidij * (countOfWorkdays - sickleaveCount) +
      tavolletidij * sickleaveCount * 0.7;
  }
  data["szja"] = Math.round(SZJA[year] * brutto);
  data["nyug"] = Math.round(NYUG[year] * brutto);
  data["egb"] = Math.round(EGB[year] * brutto);
  data["munk"] = Math.round(MUNK[year] * brutto);
  data["szoho"] = Math.round(SZOHO[year] * brutto);
  data["szak"] = Math.round(SZAK[year] * brutto);

  /**
 * A sorrend a következő:
   SZJA-mentes anyák kedvezménye (4+ gyermek)
   25 év alatti fiatalok kedvezménye
   30 év alatti anyák kedvezménye
   Személyi kedvezmény
   Első házasok kedvezménye
   Családi kedvezmény
   Családi járulékkedvezmény
 */
  if (szjaMentesAnya && year >= 2020) {
    data["szja"] = 0;
  }
  if (fiatal && FIATAL_KEDVEZMENY_MAX[year]) {
    data["szja"] -= FIATAL_KEDVEZMENY_MAX[year];
  }
  if (fiatalanya && year >= 2026) {
    // 2026-tól teljes SZJA mentesség
    data["szja"] = 0;
  } else if (fiatalanya && year >= 2023 && !fiatal) {
    // 2023-2025 között fix összegű kedvezmény
    data["szja"] -= FIATAL_KEDVEZMENY_MAX[year];
  }
  if (szemelyi) {
    data["szja"] -= Math.round(MINIMALBER[year] / 3 / 100) * 100 * SZJA[year];
  }
  if (elsoHazas) {
    data["szja"] -= Math.round(33335 * SZJA[year]);
  }
  data["szja"] = Math.max(0, data["szja"]);

  var kedvezmeny = 0;
  var ossz = parseInt(kedv) + parseInt(nemkedv);
  switch (ossz) {
    case 0:
      break;
    case 1:
      kedvezmeny += CSALADI[year][1] * kedv;
      break;
    case 2:
      kedvezmeny += CSALADI[year][2] * kedv;
      break;
    default:
      kedvezmeny += CSALADI[year][3] * kedv;
      break;
  }
  const maradekSzja = data["szja"]
  if (kedvezmeny > maradekSzja) {
    data["szja"] = 0;
    kedvezmeny -= maradekSzja;
    ["egb", "nyug"].forEach(function(val) {
      if (data[val] >= kedvezmeny) {
        data[val] -= kedvezmeny;
        kedvezmeny = 0;
      } else {
        kedvezmeny -= data[val];
        data[val] = 0;
      }
    });
  } else {
    data["szja"] -= kedvezmeny;
  }

  data["netto"] = Math.round(
    brutto - data["szja"] - data["nyug"] - data["egb"] - data["munk"]
  );
  return data;
}

export function calcWorkDays(year, month) {
  var d = new Date(year, month - 1, 1);
  var cnt = 0;
  while (d.getMonth() === month - 1) {
    var day = d.getDay();
    if (isWorkday(d)) {
      cnt++;
    }
    d.setDate(d.getDate() + 1);
  }
  return cnt;
}

export function isWorkday(date) {
  var day = date.getDay();
  var dateStr = date.toISOString().substr(0, 10);
  if (dateStr in SPECIAL_DAYS) {
    return SPECIAL_DAYS[dateStr];
  }
  return day !== 6 && day !== 0;
}



//////////////////
// WEBPACK FOOTER
// ./src/js/main.js
// module id = 0
// module chunks = 0